export enum QuickEntryAddTypeEnums {
  DURATION = 'duration',
  EXPENSE = 'expense',
}
